var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7176 15.0117V3.30534H37.1849V0H34.0174V3.30534H15.5626V0H12.395V3.30534H0V44.071H49.8554L49.7176 15.0117ZM3.16759 6.61066H12.2573V9.77827H15.4249V6.61066H33.8796V9.77827H37.0473V6.61066H46.4123V12.6704H3.0299V6.61066H3.16759ZM3.16759 41.0412V15.9758H46.55V41.0412H3.16759Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Calendar1.47c8ae496f05fbf7e909bbcbc33cdc0e.svg";